<section class="mapv2-tickets">
    <mat-radio-group [(ngModel)]="ticketId" (change)="selectTicket()">
        <label class="mapv2-tickets-item" *ngFor="let ticket of place?.tickets">
            <mat-radio-button
                [value]="ticket.id"
                [hidden]="ticketId == ticket.id"
            ></mat-radio-button>

            <button mat-icon-button
                class="delete-ticket-item"
                [hidden]="ticketId != ticket.id"
                (click)="unselectTicket()">
                <mat-icon class="material-icons-outlined">close</mat-icon>
            </button>

            <div class="info">
                <h5>{{ ticket.name }}</h5>
                <p>{{ place.row }} {{ place.number }}</p>
                <p>{{ ticket.lotName }}</p>
            </div>

            <div class="price">
                <h5>R$ {{ amount(ticket.price) | number:'1.2-2' }}</h5>
                <p>R$ {{ amount(ticket.fee) | number:'1.2-2' }} (Taxa)</p>
            </div>
        </label>
    </mat-radio-group>
</section>
  